import config from '../app-config';
import mainImg from '../images/main-img.png';
import StartImbyTool from './StartImbyTool'

const HeroPanel = () => {
    return (
        <div className="row pt-5 align-items-center justify-content-center">
            <div className="col-lg-6">
                <div className="well well-primary pt-12 ml-3 text-dark">
                    <div className="row align-items-end">
                        <div className="col-lg-10">
                            <h1 className="text-uppercase">{config.callToAction.titleShortText}</h1>
                            <div className="col-12 col-sm-12">
                                <p>{config.callToAction.shortText}<span><b>{config.callToAction.responseDate}</b></span></p>
                            </div>
                        </div>
                        <StartImbyTool classNames="col-6 offset-lg-9 d-none d-lg-block position-absolute" />
                    </div>
                    <div className="row">
                        <a type="button" className="btn btn-collapse" href="#info-text-expanded" aria-expanded="true">
                            Lees meer
                        </a>
                    </div>
                </div>

            </div>
            <StartImbyTool classNames="d-lg-none pt-2 col-6" />
            <div className="col-lg-6">
                <img className="img-fluid p-2" src={mainImg} alt="afbeelding impressie IMBY"></img>
            </div>
        </div>
    );
}

export default HeroPanel;